import { render, staticRenderFns } from "./AddCreditForm.vue?vue&type=template&id=39482d34"
import script from "./AddCreditForm.vue?vue&type=script&lang=js"
export * from "./AddCreditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports